import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import * as actions from "./actions";
import { map, catchError, tap } from "rxjs/operators";
import { of } from "rxjs";
import { LoginService } from "@services/login.service";

@Injectable()
export class LoginEffects {
    loginEffect$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actions.loginAttempt),
            catchError((e) => of(actions.loginFailure({ error: e.message }))),
        );
    });

    logoutEffect$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actions.logoutAttempt),
            tap((action) => this.loginService.logout()),
            map((action) => actions.logoutSuccess()),
            catchError((e) => of(actions.loginFailure({ error: e.message }))),
        );
    });

    constructor(
        private actions$: Actions,
        private loginService: LoginService,
    ) {}
}
